// A copy of the default student messages as-of December 13, 2019, jslib 1.16.0
import { studentMessagesEN } from './lib/intl/en-US';

export const programId = '5ebc64e829df461a7ad67ac4';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },

    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': studentMessagesEN,
    },
};
